import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile-media-pro',
    templateUrl: './profile-media-pro.component.html',
    styleUrls: ['./profile-media-pro.component.scss'],
    standalone: false
})
export class ProfileMediaProComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
